import React from "react";
import {School} from "@material-ui/icons";

export default ({href, description}) => {
  return (
    <a href={href} target="_blank">
      <p
        className="text-muted text-xsmall"
        style={{
          display: "flex",
          alignItems: "center"
        }}>
        <School
          style={{
            width: 16,
            height: 16,
            marginRight: 6
          }}
        />
        &nbsp;
        {description}
      </p>
    </a>
  );
};



// WEBPACK FOOTER //
// ./src/components/HelpText/index.jsx